'use client';

import React from 'react';
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Wallet, Users, Building2 } from "lucide-react";

interface WalletTypeSelectionProps {
  onTypeSelect: (type: 'personal' | 'family' | 'business') => void;
  selectedType?: 'personal' | 'family' | 'business';
}

const WalletTypeSelection: React.FC<WalletTypeSelectionProps> = ({
  onTypeSelect,
  selectedType
}) => {
  return (
    <div className="space-y-4">
      <Label>Wallet Type</Label>
      <RadioGroup
        value={selectedType}
        onValueChange={(value: 'personal' | 'family' | 'business') => onTypeSelect(value)}
        className="grid grid-cols-1 sm:grid-cols-3 gap-4"
      >
        <Card className="relative">
          <RadioGroupItem
            value="personal"
            id="personal"
            className="peer sr-only"
          />
          <Label
            htmlFor="personal"
            className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-popover p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary cursor-pointer"
          >
            <Wallet className="h-6 w-6 mb-2" />
            <span className="font-medium">Personal</span>
            <span className="text-xs text-muted-foreground text-center">
              For individual use
            </span>
          </Label>
        </Card>

        <Card className="relative">
          <RadioGroupItem
            value="family"
            id="family"
            className="peer sr-only"
          />
          <Label
            htmlFor="family"
            className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-popover p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary cursor-pointer"
          >
            <Users className="h-6 w-6 mb-2" />
            <span className="font-medium">Family</span>
            <span className="text-xs text-muted-foreground text-center">
              For shared expenses
            </span>
          </Label>
        </Card>

        <Card className="relative">
          <RadioGroupItem
            value="business"
            id="business"
            className="peer sr-only"
          />
          <Label
            htmlFor="business"
            className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-popover p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary cursor-pointer"
          >
            <Building2 className="h-6 w-6 mb-2" />
            <span className="font-medium">Business</span>
            <span className="text-xs text-muted-foreground text-center">
              For business finances
            </span>
          </Label>
        </Card>
      </RadioGroup>
    </div>
  );
};

export default WalletTypeSelection; 